import React, { Component } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import CountryWithFlag from './CountryWithFlag';
import TrueFalseSign from './TrueFalseSign';
import EditableCell from './EditableCell';
import SimpleDropdown from './SimpleDropdown';
import CountrySimpleDropdown from './CountrySimpleDropdown';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import SimpleMulipleDropdown from './SimpleMulipleDropdown';
import '../Account.css';
import ReactTableWithContextMenu from './ReactTableWithContextMenu';
import { AddressContextMenu } from './AddressContextMenu';
import { matchSorter } from 'match-sorter';

// Set NoData component of React table
import { ReactTableDefaults } from 'react-table';
import AddressContextMenuContainer from '../Container/AddressContextMenuContainer';
Object.assign(ReactTableDefaults, {
  NoDataComponent: () => <span></span>,
});

const ContextMenuTable = ReactTableWithContextMenu(ReactTable);

const renderEditable = (cellInfo) => (
  <div
    style={{ backgroundColor: '#fafafa' }}
    contentEditable
    suppressContentEditableWarning
    onBlur={(e) => {
      const data = [...this.state.data];
      data[cellInfo.index][cellInfo.column.id] = e.target.innerHTML;
      this.setState({ data });
    }}
    dangerouslySetInnerHTML={{
      __html: this.state.data[cellInfo.index][cellInfo.column.id],
    }}
  />
);

const billingShippingOptions = [
  { label: 'billing', value: 'billing' },
  { label: 'shipping', value: 'shipping' },
];

const emptyRow = [
  {
    Country: '',
    state: '',
    city: '',
    postal_code: '',
    active: '',
  },
];

const USA_CODE = 2;

export default class AccountList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newAddress: {
        country: '',
        state: '',
        city: '',
        address: '',
        postal_code: '',
        type: '',
        account_id: this.props.AccountID,
        selectedCountry: {},
      },
      validationError: {
        country: false,
        address: false,
      },
      addresses: [],
    };

    this.onNewAddressChange = this.onNewAddressChange.bind(this);
    this.onNewTypeChange = this.onNewTypeChange.bind(this);
    this.onNewCountryChange = this.onNewCountryChange.bind(this);
    this.onActiveChange = this.onActiveChange.bind(this);
    this.onAddressChange = this.onAddressChange.bind(this);
    this.onSubmitChangedAddress = this.onSubmitChangedAddress.bind(this);
    this.onTypeChange = this.onTypeChange.bind(this);
    this.onInlineTypeChange = this.onInlineTypeChange.bind(this);
    this.onNewAddressSubmit = this.onNewAddressSubmit.bind(this);
  }

  componentDidMount() {
    this.setState({ addresses: this.props.AddressList });
  }

  onSubmitChangedAddress(row) {
    this.props.updateAddressRequest(
      this.state.addresses[row.index],
      this.state.addresses[row.index].id
    );
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ addresses: nextProps.AddressList });
    if (this.props.AccountID != nextProps.AccountID) {
      this.setState({
        newAddress: {
          country: '',
          state: '',
          city: '',
          address: '',
          postal_code: '',
          type: '',
          account_id: nextProps.AccountID,
          selectedCountry: {},
        },
      });
    }
  }

  onAddressChange(row, e) {
    const data = [...this.state.addresses];
    data[row.index][row.column.id] = e.target.value;
    this.setState({ addresses: data });
  }

  onTypeChange(row, type) {
    const data = [...this.state.addresses];
    data[row.index].type = type;
    this.setState({ addresses: data });
  }

  onCountryChange(row, e) {
    const data = [...this.state.addresses];
    data[row.index].selectedCountry = e.target.value;
    data[row.index].country = e.target.value.CountryID;
    this.setState({ addresses: data });
  }

  onInlineTypeChange(address, type) {
    this.props.updateAddressRequest(
      { ...address, ...{ type: type } },
      address.id
    );
  }

  onActiveChange(address) {
    this.props.updateAddressRequest(
      { ...address, ...{ active: !address.active } },
      address.id
    );
  }

  onNewAddressChange(e) {
    // Remove validation error when address have valid value
    if (e.target.name === 'address') {
      if (e.target.value !== '') {
        this.setState({
          validationError: {
            ...this.state.validationError,
            address: false,
          },
        });
      }
    }
    const data = {};
    data[e.target.name] = e.target.value;
    this.setState({ newAddress: { ...this.state.newAddress, ...data } });
  }

  onNewCountryChange(e) {
    this.setState({
      newAddress: {
        ...this.state.newAddress,
        ...{
          selectedCountry: e.target.value,
          country: e.target.value.CountryID,
        },
      },
      validationError: {
        ...this.state.validationError,
        country: false,
      },
    });
  }

  onNewTypeChange(types) {
    this.setState({
      newAddress: {
        ...this.state.newAddress,
        ...{ type: types },
      },
    });
  }

  onNewAddressSubmit() {
    // validate input values.
    if (
      typeof this.state.newAddress.country == 'string' ||
      this.state.newAddress.country == null
    ) {
      if (this.state.newAddress.address === '') {
        this.setState({
          validationError: {
            ...this.state.validationError,
            address: true,
            country: true,
          },
        });
      } else {
        this.setState({
          validationError: {
            ...this.state.validationError,
            country: true,
          },
        });
      }
      return;
    }
    if (this.state.newAddress.address === '') {
      this.setState({
        validationError: {
          ...this.state.validationError,
          address: true,
        },
      });
      return;
    }

    this.props.insertAddress(this.state.newAddress);
    this.setState({
      newAddress: {
        country: '',
        state: '',
        city: '',
        address: '',
        postal_code: '',
        type: '',
        account_id: this.props.AccountID,
        selectedCountry: {},
        pageSize: 10,
      },
    });
  }

  render() {
    const {
      country,
      address,
      city,
      state,
      type,
      postal_code,
      selectedCountry,
    } = this.state.newAddress;

    const { addresses } = this.state;

    const { AddressList } = this.props;

    const nomalCellGenerator = (row) =>
      row.original.isEdit ? (
        <input
          style={{ width: '100%' }}
          value={addresses[row.index][row.column.id]}
          onChange={(e) => this.onAddressChange(row, e)}
        />
      ) : (
        <div style={{ overflow: 'auto' }}>
          <span>{row.value}</span>
        </div>
      );

    const nomalFooter = (value, name, error) => (
      <input
        style={
          error ? { border: 'solid 1px red', width: '100%' } : { width: '100%' }
        }
        value={value}
        name={name}
        onChange={this.onNewAddressChange}
      />
    );

    const pageLength =
      AddressList && AddressList.length < 10
        ? AddressList.length
        : AddressList
          ? 10
          : 1;

    return (
      <React.Fragment>
        <ContextMenuTable
          style={{
            overflow: 'scroll',
          }}
          data={AddressList ? [...AddressList] : []}
          filterable
          columns={[
            {
              Header: 'Active',
              Cell: (row) =>
                row.original.isEdit ? (
                  <input
                    type="button"
                    value="OK"
                    onClick={() => this.onSubmitChangedAddress(row)}
                  />
                ) : (
                  <input
                    type="checkbox"
                    checked={row.original.active}
                    onChange={() => this.onActiveChange(row.original)}
                  />
                ),
              Footer: <button onClick={this.onNewAddressSubmit}>Add</button>,
              width: 50,
            },
            {
              Header: 'Country',
              accessor: 'countryName',
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, {
                  keys: ['countryName'],
                }),
              filterAll: true,
              Cell: (row) =>
                row.original.isEdit ? (
                  <CountrySimpleDropdown
                    list={this.props.countryList}
                    value={
                      addresses[row.index].selectedCountry
                        ? addresses[row.index].selectedCountry.Name
                        : addresses[row.index].countryName
                    }
                    name="country"
                    onChange={(e) => this.onCountryChange(row, e)}
                  />
                ) : (
                  <CountryWithFlag country={row.value} />
                ),
              Footer: (
                <CountrySimpleDropdown
                  error={this.state.validationError.country}
                  list={this.props.countryList}
                  value={selectedCountry.Name}
                  name="country"
                  onChange={this.onNewCountryChange}
                />
              ),
              width: 200,
            },
            {
              Header: 'State',
              accessor: 'state',
              width: 130,
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, {
                  keys: ['state'],
                }),
              filterAll: true,
              Cell: (row) =>
                row.original.isEdit ? (
                  <SimpleDropdown
                    list={this.props.stateList.map((state) => ({
                      Name: `${state.name.trim()} (${state.code})`,
                    }))}
                    value={addresses[row.index][row.column.id]}
                    name="state"
                    onChange={(e) => this.onAddressChange(row, e)}
                  />
                ) : (
                  <span>{row.value}</span>
                ),
              Footer:
                this.state.newAddress.selectedCountry === USA_CODE ? (
                  <input
                    type="text"
                    style={{ width: '100%' }}
                    onChange={this.onNewAddressChange}
                  />
                ) : (
                  <SimpleDropdown
                    selectedCountry={this.state.newAddress.state}
                    list={this.props.stateList.map((state) => ({
                      Name: `${state.name.trim()} (${state.code})`,
                    }))}
                    value={state}
                    name="state"
                    onChange={this.onNewAddressChange}
                  />
                ),
            },
            {
              Header: 'City',
              accessor: 'city',
              filterAll: true,
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, {
                  keys: ['city'],
                }),
              Cell: nomalCellGenerator,
              Footer: nomalFooter(city, 'city'),
              width: 200,
            },
            {
              Header: 'Address',
              accessor: 'address',
              filterAll: true,
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, {
                  keys: ['address'],
                }),

              Cell: nomalCellGenerator,
              Footer: nomalFooter(
                address,
                'address',
                this.state.validationError.address
              ),
              width: 500,
            },
            {
              Header: 'Postal Code',
              accessor: 'postal_code',
              filterMethod: (filter, rows) =>
                matchSorter(rows, filter.value, {
                  keys: ['postal_code'],
                }),
              filterAll: true,
              Cell: nomalCellGenerator,
              Footer: nomalFooter(postal_code, 'postal_code'),
              width: 100,
            },
            {
              Header: 'Type',
              Cell: (row) =>
                row.original.isEdit ? (
                  <SimpleMulipleDropdown
                    simpleValue={true}
                    clearable={false}
                    style={{ height: '15px' }}
                    multi={true}
                    name="type"
                    value={addresses[row.index].type}
                    onChange={(type) => this.onTypeChange(row, type)}
                    options={billingShippingOptions}
                  />
                ) : (
                  <SimpleMulipleDropdown
                    simpleValue={true}
                    clearable={false}
                    style={{ height: '15px' }}
                    multi={true}
                    name="type"
                    value={
                      (row.original.default_billing_address == row.original.id
                        ? 'billing'
                        : '') +
                      (row.original.default_shipping_address == row.original.id
                        ? row.original.default_billing_address ==
                          row.original.id
                          ? ',shipping'
                          : 'shipping'
                        : '')
                    }
                    onChange={(type) =>
                      this.onInlineTypeChange(row.original, type)
                    }
                    options={billingShippingOptions}
                  />
                ),
              Footer: (
                // <SimpleDropdown list={[{ Name: "Shipping" }, { Name: "Billing" }]} value={newType} name="Type" onChange={this.onNewAddressChange} />
                <SimpleMulipleDropdown
                  simpleValue={true}
                  clearable={false}
                  style={{ height: '15px' }}
                  multi={true}
                  name="type"
                  value={type}
                  onChange={this.onNewTypeChange}
                  options={billingShippingOptions}
                />
              ),
              width: 200,
            },
          ]}
          contextMenuComponent={AddressContextMenuContainer}
          contextMenuName="Address"
          defaultPageSize={10}
          showPagination={true}
          className="-striped -highlight"
          getTableProps={(state, rowInfo, column) => {
            return {
              style: {
                overflow: 'initial',
              },
            };
          }}
          getTfootTdProps={(state, rowInfo, column) => {
            return {
              style: {
                overflow: 'initial',
              },
            };
          }}
          getTdProps={(state, rowInfo, column) => {
            return {
              style: {
                overflow: 'initial',
                opacity: !!rowInfo?.original.active ? 1 : 0.5,
              },
            };
          }}
          getTbodyProps={(state, rowInfo, column) => {
            return {
              style: {
                overflow: 'initial',
              },
            };
          }}
          getTheadFilterThProps={(state, rowInfo, column) => {
            return {
              style: {
                overflow: 'initial',
              },
            };
          }}
        />
      </React.Fragment>
    );
  }
}
